export const LESSONS = 'LESSONS';
export const LESSON = 'LESSON';


// WEBPACK FOOTER //
// ./src/store/modules/lesson/mutation-types.js